import { useEffect, useState } from "react";
import { CalendarDays, Clock, MapPin } from "lucide-react";
import axios, { API } from "@/lib/api";
import StatusBadge from "@/components/shared/StatusBadge";
import EmptyState from "@/components/shared/EmptyState";

function formatDate(d) {
  if (!d) return "-";
  return new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
}

export default function ManasikPreview() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/manasik`, { params: { status: "upcoming" } }).then(({ data }) => setEvents(data.slice(0, 3))).catch(() => setEvents([]));
  }, []);

  return (
    <section className="bg-[#F5F9F7] py-20" data-testid="manasik-preview-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Jadwal Terdekat</span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Jadwal Manasik Mendatang</h2>
        </div>

        {events === null ? null : events.length === 0 ? (
          <div className="mt-10"><EmptyState title="Belum ada jadwal manasik" description="Jadwal manasik terbaru akan segera diinformasikan." /></div>
        ) : (
          <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
            {events.map((e) => (
              <div key={e.id} data-testid={`manasik-card-${e.id}`} className="rounded-2xl bg-white p-6 shadow-[0_2px_16px_rgba(15,107,79,0.06)]">
                <StatusBadge status={e.status} />
                <h3 className="mt-4 font-heading text-lg font-semibold text-[#1F2937]">{e.title}</h3>
                <div className="mt-4 space-y-2 text-sm text-[#64748B]">
                  <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4" /> {formatDate(e.date)}</p>
                  <p className="flex items-center gap-2"><Clock className="h-4 w-4" /> {e.time}</p>
                  <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {e.location}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
